import { defineWebModule } from '@nexus/core-web';
import { de } from '../i18n/de';
import { en } from '../i18n/en';
import { manifest } from '../manifest';

// Public web API for modules that depend on the legal texts (README, "Öffentliche API").
export { LegalBasisInput, type LegalBasisInputProps } from './legal-basis-input';
export { LegalReferenceLinks, type LegalReferenceLinksProps } from './legal-reference-links';

/** Listed in apps/web/src/modules.ts. Pages load on first visit, each module is its own bundle. */
export const webModule = defineWebModule({
  manifest,
  messages: { de, en },
  pages: [
    { path: '/legal', load: () => import('./legal-page'), permission: 'legal.norm.read' },
    {
      path: '/legal/sources',
      load: () => import('./sources-page'),
      permission: 'legal.source.manage',
    },
    {
      path: '/legal/sources/$id',
      load: () => import('./source-page'),
      permission: 'legal.norm.read',
    },
  ],
  guides: [
    {
      id: 'legal.texts',
      title: 'legal.guides.texts.title',
      summary: 'legal.guides.texts.summary',
      permission: 'legal.norm.read',
      pages: ['/legal', '/legal/sources/$id'],
      content: {
        de: () => import('./guides/texts.de.md?raw'),
        en: () => import('./guides/texts.en.md?raw'),
      },
    },
    {
      id: 'legal.sources',
      title: 'legal.guides.sources.title',
      summary: 'legal.guides.sources.summary',
      permission: 'legal.source.manage',
      pages: ['/legal/sources'],
      content: {
        de: () => import('./guides/sources.de.md?raw'),
        en: () => import('./guides/sources.en.md?raw'),
      },
    },
  ],
});
